import { render, staticRenderFns } from "./EditorStyleSettingsModal.vue?vue&type=template&id=7dd2a52f&scoped=true"
import script from "./EditorStyleSettingsModal.vue?vue&type=script&lang=ts"
export * from "./EditorStyleSettingsModal.vue?vue&type=script&lang=ts"
import style0 from "./EditorStyleSettingsModal.vue?vue&type=style&index=0&id=7dd2a52f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd2a52f",
  null
  
)

export default component.exports